interface BothIcons {
  mono: string; //svg
  color: string; //svg
  title: string;
}

interface ColorIconOnly {
  mono: null;
  color: string; //svg
  title: string;
}

interface MonoIconOnly {
  mono: string; //svg
  color: null; //svg
  title: string;
}

export type Icon = BothIcons | ColorIconOnly | MonoIconOnly;

export const iconColors = ["single", "multi", "gradientPeachCyan"] as const;
export type IconColors = typeof iconColors[number];

export const iconSizes = {
  sml: 16,
  med: 24,
  lrg: 32,
  xlrg: 40,
  xxlrg: 48,
} as const;
export type IconSizes = keyof typeof iconSizes;
